<template>
  <v-dialog
    :value="value"
    @click:outside="handleCancel"
    @cancel="handleCancel"
    width="600px"
  >
    <v-card>
      <v-form ref="form-document">
        <v-card-title class="headline">{{ title }} </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <DatetimePicker
                v-model="field.expire_date"
                :min="minDate"
                :max="maxDate"
                :label="$t('commons.date.expire_date')"
                :textFieldProps="{
                  placeholder: $t('commons.date.expire_date'),
                  rules: rules.expire_date
                }"
              />
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="handleSave"
            >{{ $t("commons.save") }}</v-btn
          >
          <v-btn
            color="error"
            @click="handleCancel"
            >{{ $t("commons.cancel") }}</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import DocumentationService from "@/services/DocumentationService"
import { required } from "@/utils/validator"
import { add, today } from "@/utils/datetime"

export default {
  name: "EditDateDocumentDialog",
  components: {
    DatetimePicker: () => import("@/components/inputs/DatetimePicker.vue")
  },
  props: {
    item: {
      type: Object
    },
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Edit File"
    },
    isFolder: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      // field: { ...this.item }
      minDate: today(),
      maxDate: null,
      field: Object.assign({}, this.item, {
        expire_date: this.item.expire_date || add(today(), 1, "month") // Si expire_date n'existe pas, ajoute 1 mois à la date actuelle
      })
    }
  },
  computed: {
    rules() {
      return {
        //name: [required, slug, max64],
        expire_date: [required],
        type: [required],
        ...this.rulesUpdate
      }
    },
    projectId() {
      return this.$store.state.app.project.id
    }
  },
  methods: {
    validate() {
      return this.$refs["form-document"].validate()
    },
    handleCancel() {
      this.$emit("close", true)
    },
    handleSave() {
      if (this.validate()) {
        let promise = null
        let expire_date = this.field.expire_date
        promise = DocumentationService.changeExpireDate(
          this,
          this.projectId,
          this.item.id,
          expire_date
        )

        return promise
          .then(response => {
            this.notify(this.$t("messages.success.edited", { entity: this.$tc("commons.file", 1) }))
            this.$emit("close", true)
            this.$emit("hasChanged", true)
            return true
          })
          .catch(error => {
            this.$emit("close", true)
            this.notify(error.message, "error")
            return false
          })
      }
    },
    notify(msg, color = "success") {
      this.$store.commit("app/message", { msg, color })
    }
  }
}
</script>
